(function () {
  window.AutoGWP = window.AutoGWP || {};
  var AutoGWP = window.AutoGWP;

  AutoGWP._suspendHook = false;
  AutoGWP._isRunning = false;
  AutoGWP._pendingRun = false;
  AutoGWP._productTagCache = AutoGWP._productTagCache || {};
  AutoGWP._collectionCache = AutoGWP._collectionCache || {};

  var FREE_GIFT_KEY = '_free_gift';

  function debugOn() {
    return !!(window.AutoGWPConfig && window.AutoGWPConfig.debug);
  }
  function log() {
    if (!debugOn()) return;
    console.log.apply(console, ['[AutoGWP]'].concat(Array.prototype.slice.call(arguments)));
  }

  function cartFetch(url, body) {
    var opts = {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts);
  }

  function isFreeGiftLine(item) {
    if (!item || !item.properties) return false;
    for (var key in item.properties) {
      if (Object.prototype.hasOwnProperty.call(item.properties, key) && String(key).indexOf(FREE_GIFT_KEY) !== -1) {
        return true;
      }
    }
    return false;
  }

  // ---------------------------
  //  Cart mutations
  // ---------------------------

  AutoGWP.add = function (variantId) {
    log('Adding free gift variant', variantId);
    var props = {};
    props[FREE_GIFT_KEY] = 'true';
    return cartFetch('/cart/add.js', { id: variantId, quantity: 1, properties: props })
      .then(function (r) { if (!r.ok) log('add error', r.status); return r; })
      .catch(function (e) { console.error('[AutoGWP] add failed', e); });
  };

  AutoGWP.remove = function (variantId) {
    log('Removing free gift variant', variantId);
    return cartFetch('/cart/change.js', { id: String(variantId), quantity: 0 })
      .then(function (r) { if (!r.ok) log('remove error', r.status); return r; })
      .catch(function (e) { console.error('[AutoGWP] remove failed', e); });
  };

  function refreshCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return Promise.resolve();
    var sectionId = drawer.getAttribute('data-id');
    if (!sectionId) return Promise.resolve();
    var url = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId);
    return cartFetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('cart-drawer');
        if (fresh) {
          drawer.innerHTML = fresh.innerHTML;
          log('Cart drawer refreshed');
        }
      })
      .catch(function (e) { console.error('[AutoGWP] drawer refresh error', e); });
  }

  AutoGWP.modifyCart = function (actions) {
    if (!actions || !actions.length) return Promise.resolve();
    log('Modifying cart', actions);
    AutoGWP._suspendHook = true;

    // Sequential so the cart state is deterministic.
    var chain = Promise.resolve();
    actions.forEach(function (a) {
      chain = chain.then(function () {
        return a.status === 'valid' ? AutoGWP.add(a.id) : AutoGWP.remove(a.id);
      });
    });

    return chain
      .then(function () {
        // Nudge the cart so the discount function re-evaluates with the new line(s).
        return cartFetch('/cart/update.js', {});
      })
      .then(refreshCartDrawer)
      .then(function () {
        if (document.body && document.body.classList.contains('template-cart')) {
          log('On cart template – reloading');
          window.location.reload();
        }
      })
      .catch(function (e) { console.error('[AutoGWP] modifyCart error', e); })
      .finally(function () { AutoGWP._suspendHook = false; });
  };

  // ---------------------------
  //  Lookups
  // ---------------------------

  function fetchTagsForHandles(handles) {
    var unique = [];
    var seen = {};
    handles.forEach(function (h) {
      if (!h) return;
      var k = h.toLowerCase();
      if (!seen[k] && !AutoGWP._productTagCache[k]) { seen[k] = true; unique.push(k); }
    });
    if (!unique.length) return Promise.resolve();
    log('Fetching tags for', unique);
    return Promise.all(unique.map(function (handle) {
      return cartFetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          AutoGWP._productTagCache[handle] = (p && Array.isArray(p.tags))
            ? p.tags.map(function (t) { return String(t).toLowerCase(); })
            : [];
        })
        .catch(function () { AutoGWP._productTagCache[handle] = []; });
    }));
  }

  function fetchCollectionHandles(collectionHandles) {
    var need = collectionHandles.filter(function (c) { return c && !AutoGWP._collectionCache[c]; });
    if (!need.length) return Promise.resolve();
    log('Fetching collection products for', need);
    return Promise.all(need.map(function (c) {
      var handles = {};
      function page(n) {
        return cartFetch('/collections/' + encodeURIComponent(c) + '/products.json?limit=250&page=' + n)
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (data) {
            var list = (data && data.products) || [];
            list.forEach(function (p) { if (p.handle) handles[p.handle.toLowerCase()] = true; });
            return list.length === 250 ? page(n + 1) : null;
          });
      }
      return page(1)
        .then(function () { AutoGWP._collectionCache[c] = handles; })
        .catch(function (e) {
          console.error('[AutoGWP] collection fetch error', c, e);
          AutoGWP._collectionCache[c] = {};
        });
    }));
  }

  // ---------------------------
  //  Rule evaluation
  // ---------------------------

  function lineMatchesScope(item, rule) {
    var handle = (item.handle || '').toLowerCase();
    switch (rule.scope) {
      case 'tag':
        return (AutoGWP._productTagCache[handle] || []).indexOf(String(rule.tag || '').toLowerCase()) !== -1;
      case 'collections':
        return (rule.collections || []).some(function (c) {
          return !!(AutoGWP._collectionCache[c] && AutoGWP._collectionCache[c][handle]);
        });
      case 'products':
        return (rule.products || []).map(function (h) { return String(h).toLowerCase(); }).indexOf(handle) !== -1;
      default:
        return true; // whole cart
    }
  }

  function giftInCart(items, variantId) {
    return items.some(function (item) {
      return item.variant_id === variantId && isFreeGiftLine(item);
    });
  }

  function evaluateRules(rules, items) {
    var actions = [];
    rules.forEach(function (rule, idx) {
      if (!rule || !rule.vid) return;
      var variantId = parseInt(rule.vid, 10);
      var qualifies = false;

      if (rule.type === 'spend') {
        var threshold = parseInt(rule.threshold, 10) || 0;
        var spend = 0;
        items.forEach(function (item) {
          if (isFreeGiftLine(item)) return;
          if (lineMatchesScope(item, rule)) spend += item.final_line_price || 0;
        });
        qualifies = threshold > 0 && spend >= threshold;
        log('Rule', idx + 1, '[spend]', rule.scope, '| threshold', threshold, '| spend', spend, '| qualifies', qualifies);
      } else {
        var requiredQty = parseInt(rule.qty, 10) || 1;
        var count = 0;
        items.forEach(function (item) {
          if (isFreeGiftLine(item)) return;
          if (lineMatchesScope(item, rule)) count += item.quantity || 0;
        });
        qualifies = count >= requiredQty;
        log('Rule', idx + 1, '[qty]', rule.scope, '| need', requiredQty, '| found', count, '| qualifies', qualifies);
      }

      var inCart = giftInCart(items, variantId);
      if (qualifies && !inCart) actions.push({ id: variantId, status: 'valid' });
      else if (!qualifies && inCart) actions.push({ id: variantId, status: 'invalid' });
    });
    return actions;
  }

  AutoGWP.run = function () {
    var config = window.AutoGWPConfig || {};
    var rules = config.rules || [];
    if (!rules.length) { log('No rules configured'); return; }

    if (AutoGWP._isRunning) { AutoGWP._pendingRun = true; log('Already running, queued'); return; }
    AutoGWP._isRunning = true;

    cartFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var handles = items.map(function (i) { return (i.handle || '').toLowerCase(); });

        var needTags = rules.some(function (r) { return r.scope === 'tag'; });
        var collectionHandles = [];
        rules.forEach(function (r) {
          if (r.scope === 'collections') collectionHandles = collectionHandles.concat(r.collections || []);
        });

        return Promise.all([
          needTags ? fetchTagsForHandles(handles) : Promise.resolve(),
          collectionHandles.length ? fetchCollectionHandles(collectionHandles) : Promise.resolve()
        ]).then(function () {
          if (!items.length) { log('Cart empty'); return; }
          var actions = evaluateRules(rules, items);
          if (actions.length) return AutoGWP.modifyCart(actions);
          log('No actions needed');
        });
      })
      .catch(function (e) { console.error('[AutoGWP] run error', e); })
      .finally(function () {
        AutoGWP._isRunning = false;
        if (AutoGWP._pendingRun) { AutoGWP._pendingRun = false; setTimeout(AutoGWP.run, 0); }
      });
  };

  // ---------------------------
  //  Hooks: fetch + XHR on cart endpoints
  // ---------------------------

  var cartEndpointRegex = /\/cart(\/add|\/change|\/update)(\.js)?(\?|$)/;

  function scheduleRun() {
    setTimeout(function () {
      try { AutoGWP.run(); } catch (e) { console.error('[AutoGWP] hook run error', e); }
    }, 0);
  }

  if (window.fetch && !window.__AutoGWPPatchedFetch) {
    window.__AutoGWPPatchedFetch = true;
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCart = cartEndpointRegex.test(url);
      return originalFetch(input, init).then(function (response) {
        if (isCart && response && response.ok && !AutoGWP._suspendHook) {
          log('fetch hook:', url);
          scheduleRun();
        }
        return response;
      });
    };
  }

  if (window.XMLHttpRequest && !window.__AutoGWPPatchedXHR) {
    window.__AutoGWPPatchedXHR = true;
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__AutoGWPIsCart = cartEndpointRegex.test(String(url || ''));
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      var xhr = this;
      if (xhr.__AutoGWPIsCart && !AutoGWP._suspendHook) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) { log('XHR hook'); scheduleRun(); }
        });
      }
      return origSend.call(this, body);
    };
  }

  // ---------------------------
  //  Initial run (cart page only)
  // ---------------------------

  function onReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') setTimeout(fn, 0);
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    if (document.body && document.body.classList.contains('template-cart')) {
      setTimeout(function () {
        try { AutoGWP.run(); } catch (e) { console.error('[AutoGWP] initial run error', e); }
      }, 300);
    }
  });
})();
